import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";
import { fmtDate, money } from "@/lib/api";
import { StatusChip } from "@/components/account/StatusChip";

export const OrderCard = ({ order }) => {
  const shown = order.items.slice(0, 3);
  const extra = order.items.length - shown.length;
  return (
    <Link
      to={`/account/orders/${order.id}`}
      data-testid={`order-${order.order_number}`}
      className="group block rounded-2xl border border-neutral-200 bg-white p-5 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-0.5 hover:border-neutral-900 hover:shadow-[0_12px_30px_-18px_rgba(0,0,0,0.35)]"
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-400">Order</p>
          <p className="font-heading text-base font-bold" data-testid={`order-${order.order_number}-number`}>
            {order.name || `#${order.order_number}`}
          </p>
          <p className="mt-0.5 text-xs text-neutral-400">{fmtDate(order.date)}</p>
        </div>
        <div className="text-right">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-neutral-400">Total</p>
          <p className="font-heading text-base font-bold" data-testid={`order-${order.order_number}-total`}>
            {money(order.total, order.currency)}
          </p>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-3">
        <div className="flex -space-x-2">
          {shown.map((i, idx) =>
            i.image ? (
              <img
                key={idx}
                src={i.image}
                alt={i.title}
                className="h-12 w-12 rounded-xl border-2 border-white bg-neutral-100 object-cover"
              />
            ) : (
              <div key={idx} className="grid h-12 w-12 place-items-center rounded-xl border-2 border-white bg-neutral-100">
                <Package size={16} className="text-neutral-400" />
              </div>
            )
          )}
          {extra > 0 && (
            <div className="grid h-12 w-12 place-items-center rounded-xl border-2 border-white bg-neutral-900 text-xs font-semibold text-white">
              +{extra}
            </div>
          )}
        </div>
        <p className="min-w-0 flex-1 truncate text-sm text-neutral-600">
          {order.items.map((i) => `${i.title} × ${i.qty}`).join(", ")}
        </p>
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-3 border-t border-neutral-100 pt-4">
        <div className="flex flex-wrap gap-2">
          <StatusChip status={order.fulfillment_status} testId={`order-${order.order_number}-fulfillment`} />
          <StatusChip status={order.payment_status} testId={`order-${order.order_number}-payment`} />
        </div>
        <span className="inline-flex items-center gap-1 text-xs font-semibold text-neutral-700">
          View details
          <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
};
